<i18n lang="yaml">
  pt:
    apply: 'Candidate-se'
  en:
    apply: 'Apply'
</i18n>

<template>
  <v-app id="inspire" class="public-layout">
    <PublicTopbar v-if="!routesWithoutTopbar" />

    <v-main class="public-layout__wrapper">
      <nuxt />
      <deck-button
        v-if="showApplyButton"
        class="public-layout__apply-button"
        size="large"
        :text="$t('apply')"
        :to="localePath({
          name: 't-tenantSlug-sign-up',
          params: {
            tenantSlug: $route.params.tenantSlug,
          },
        })"
      />
    </v-main>

    <Snackbar is-public />
    <TheDialog />
  </v-app>
</template>

<script>
import Snackbar from '~/components/Snackbar';
import TheDialog from '~/components/dialogs/the-dialog';
import PublicTopbar from '~/components/topbars/public-topbar';
import DeckButton from '~/deck/button';
import { workspace } from '~/mixins/workspace';
import { mapMutations } from 'vuex';
import ROUTES from '~/assets/javascript/constants/routes';

const routesWithoutTopbar = [
  't-tenantSlug-login',
  't-tenantSlug-sign-up',
  't-tenantSlug-reset-password',
];

export default {
  name: 'Public',
  components: {
    Snackbar,
    TheDialog,
    DeckButton,
    PublicTopbar,
  },
  mixins: [workspace({ isPublic: true })],
  head() {
    return this.$buildHead();
  },
  computed: {
    routesWithoutTopbar() {
      return routesWithoutTopbar.includes(this.getRouteBaseName());
    },
    isPublicViewOrRecord() {
      return this.$route.name?.includes(ROUTES.public.view.routeName)
        || this.$route.name?.includes(ROUTES.public.view.record.routeName);
    },
    showApplyButton() {
      return this.isPublicViewOrRecord && !this.$auth.loggedIn && this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.setOutsideStudio();
    this.setCurrentEnvironment('public');
    const utmsObject = this._.pickBy(this.$route.query, (_value, key) => this._.startsWith(key, 'utm_'));

    if (!this._.isEmpty(utmsObject)) {
      window.analytics.track('referredFrom', utmsObject);
    }
  },
  destroyed() {
    this.resetWorkspace();
  },
  methods: {
    ...mapMutations('environment', ['setCurrentEnvironment']),
    ...mapMutations('studio', ['setOutsideStudio']),
    ...mapMutations('workspace', ['resetWorkspace']),
  },
};
</script>
<style lang="scss">
.public-layout {
  --z-the-landscape-max-width: 1280px;

  // Needs to be redeclared the same as :root in order replace the overriden var current value there
  // https://stackoverflow.com/a/63836563
  --z-the-landscape-to-viewport-distance: calc((100vw - var(--z-the-landscape-max-width)) / 2);

  --z-the-landscape-inline-spacing: max(
    var(--z-the-landscape-to-viewport-distance),
    var(--z-the-landscape-outer-spacing)
  );

  --z-main-background-color: #FFFFFF;
  --z-kanban-background-color: #FFFFFF;

  --z-kanban-column-background-color: #F5F5F5;
  --z-matrix-column-background-color: #F5F5F5;

  --z-calendar-background-color: #FFFFFF;
  --z-calendar-day-background-color: #F5F5F5;
}

.public-layout__apply-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  margin: 16px auto;
  width: 100%;
  max-width: fit-content;
}
</style>
